import { Fragment } from 'react'
import { Grid, Typography, Divider,Skeleton } from '@mui/material'

export const ListItem = () => {
  return (
    <Grid container spacing={2}
      sx={{
        cursor: 'pointer',
        paddingTop: 1.5,
      }}>
      <Grid item xs={3} sm={2}>
        <Typography align="center">
          <Skeleton animation="wave" variant="circle"
            sx={{
              width: 40,
              height: 40,
              display: 'inline-block',
              verticalAlign: 'text-top',
              color: '#00b6b0',
            }}/>
        </Typography>
      </Grid>
      <Grid item xs={9} sm={10}>
        <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
          <Skeleton animation="wave" variant="rect" height={15} width={75} style={{ marginRight: 20 }} />
          <Skeleton animation="wave" variant="rect" height={15} width={120}/>
        </div>
        <Skeleton animation="wave" variant="rect" height={15}
          sx={{
            margin: '8px 0',
          }}/>
        <Skeleton animation="wave" variant="rect" height={15} width={150} />
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
    </Grid>
  )
}


const ListItemLoadingSkeleton = () => {

  return (
    <div
      style={{
        height: '368px',
        maxHeight: '368px',
        overflow: 'hidden',
        '@media (max-width: 600px)': { height: '100%' },
      }}>
      {Array.from(Array(4).keys()).map((_, index) => (
        <Fragment key={`mynotification-skeleton-${index}`} >
          <ListItem />
        </Fragment>
      ))}
    </div>
  )
}

export default ListItemLoadingSkeleton
